import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    buttonLabel: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Label for redirect to advanced search */
            buttonLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "QuickSearchResultsFooter.buttonLabel?c=3aa7jonhw20q6", defaultMessage: "See all results" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
